import React, { useContext, useState } from 'react';
import { Badge, Card, Group, Image, Stack, Tabs, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { Context as EcommmerceContext } from '../../../providers/EcommerceProvider';
import EcomStoreAdminListView from './EcomStoreAdminListView';
import EcomStoreSettingsView from './EcomStoreSettingsView';

const VIEW_TABS = [
  {
    value: 'ADMINS',
    label: 'Admins'
  },
  {
    value: 'SETTINGS',
    label: 'Settings'
  }
];

const EcomStoreDetails = () => {
  const { pkEcomStore } = useParams();
  const { state } = useContext(EcommmerceContext);
  const [activeTab, setActiveTab] = useState('ADMINS');
  const ecomStore = state.ecomStores.value.find(
    (a) => a.pkEcomStore.toString() === pkEcomStore
  );

  return ecomStore ? (
    <Card
      shadow="lg"
      sx={{
        flex: 1,
        border: 'solid 1px lightgrey',
        padding: 15,
        gap: 5,
        alignSelf: 'stretch'
      }}
    >
      <Group style={{ justifyContent: 'space-between' }}>
        <Group sx={{ flexWrap: 'nowrap' }}>
          <Image
            fit="contain"
            height={50}
            src={ecomStore.logoImageUrl ?? null}
            width={50}
          />
          <Text sx={{ fontSize: 18 }} weight={700}>
            {ecomStore.name}
          </Text>
        </Group>
        <Group sx={{ gap: 8 }}>
          {ecomStore.deleted ? (
            <Badge color="red" variant="filled">
              Deleted
            </Badge>
          ) : ecomStore.sandboxEnabled ? (
            <Badge color="yellow" variant="filled">
              Sandbox
            </Badge>
          ) : (
            <Badge color="green" variant="filled">
              Live
            </Badge>
          )}
          {ecomStore.isDemoStore && (
            <Badge color="blue" variant="filled">
              DEMO MODE
            </Badge>
          )}
        </Group>
      </Group>

      <Stack sx={{ gap: 10 }}>
        <Tabs onTabChange={setActiveTab} value={activeTab}>
          <Stack sx={{ gap: 20 }}>
            <Tabs.List>
              {VIEW_TABS.map((a) => (
                <Tabs.Tab key={a.value} value={a.value}>
                  {a.label}
                </Tabs.Tab>
              ))}
            </Tabs.List>
          </Stack>
        </Tabs>
        {activeTab === 'ADMINS' ? (
          <EcomStoreAdminListView ecomStore={ecomStore} />
        ) : (
          <EcomStoreSettingsView ecomStore={ecomStore} />
        )}
      </Stack>
    </Card>
  ) : (
    <></>
  );
};

EcomStoreDetails.propTypes = {};

export default EcomStoreDetails;
